import { render, staticRenderFns } from "./userNotifications.vue?vue&type=template&id=62e22985&lang=pug"
import script from "./userNotifications.vue?vue&type=script&lang=js"
export * from "./userNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports